import React, { useEffect, useState } from "react";
import SwapHeaderMenu from "../swap/SwapHeaderMenu";
import AddLiquidity from "./AddLiquidity";
import RemoveLiquidity from "./RemoveLiquidtiy";

const ManageLiquidityModal = ({ setIsModalOpen, isLpLoading1, userLiq1, getUserAmt }: any) => {
  const [activeMenu, setActiveMenu] = useState("Add Liquidity");
  return (
    <div className="coin-select-container liquidity-container">
      <div className="coin-select-header liquidity-header">
        Manage Liquidity
      </div>
      <div className="coin-select-input-head liquidity-subhead">
        <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("Add Liquidity")}
          name={"Add Liquidity"}
        />
        <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("Remove Liquidity")}
          name={"Remove Liquidity"}
        />
      </div>
      <div className="coin-select-input-wrapper">
        {activeMenu === "Add Liquidity" ? (
          <AddLiquidity getUserAmt={getUserAmt} setIsModalOpen={setIsModalOpen}/>
        ) : (
          <RemoveLiquidity isLpLoading1 = {isLpLoading1} userLiq1 = {userLiq1} getUserAmt={getUserAmt} setIsModalOpen={setIsModalOpen}/>
        )}
      </div>
    </div>
  );
};

export default ManageLiquidityModal;
